import { Injectable } from '@angular/core';
import { FormControl,FormGroup,Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { AccountsReceivableLedgerTemplateEntity } from '../../../dave-data-module/entities/accounts-receivable-ledger-template.entity';
import { AccountsReceivableLedgerTypeEnum } from '../../../dave-data-module/entities/accounts-receivable-ledger.entity';
import { MaterialDataService } from '../../../dave-data-module/services/material-data.service';
import { State } from '../../../dave-data-module/State';
import { isNotNullOrUndefined } from '../../../helper/helper';
import * as mjsHelper from '../../../helper/math-js-helper';
import { getCostFromArlTemplate } from './arl-calculation.helper';
import { FormControlCache } from './formcontrol-cache';

export type calculationArlTemplateFormGroup = FormGroup<calculationArlTemplateForm>;
export type calculationArlTemplateForm = {
    costAmountWithoutTax: FormControl<number>;
    BaseCost: FormControl<number>;
    CostAmount: FormControl<number>;
    Quantity: FormControl<number>;
    QuantityTypeId: FormControl<number>;
    Information: FormControl<string>;
    BookingText: FormControl<string>;
    Type: FormControl<AccountsReceivableLedgerTypeEnum>;
    ResourceId: FormControl<number>;
    MaterialId: FormControl<number>;
    JobSpecificationId: FormControl<number>;
    IsVisible: FormControl<boolean>;
    IsOptional: FormControl<boolean>;
    CrossedOut: FormControl<boolean>;
    IndividuallyCostCalculation: FormControl<boolean>;
    CostAmountAllowance: FormControl<number>;
    QuantityFormula: FormControl<string>;
    QuantityFormulaUsedVariables: FormControl<string[]>;
    SurchargeOverride: FormControl<number | null>;
};

@Injectable()
export class CalculationArlTemplateFormDataService extends FormControlCache<calculationArlTemplateFormGroup> {
    constructor(private store: Store<State>, private materialDataService: MaterialDataService) {
        super();
    }
    async getFormByEntity(arl: AccountsReceivableLedgerTemplateEntity | null, childrenVisible: boolean): Promise<calculationArlTemplateFormGroup> {
        let form: calculationArlTemplateFormGroup = arl && this.getForm(arl.Id);
        if (!form) {
            let costAmount = arl?.CostAmount;
            if (arl) {
                const c = await getCostFromArlTemplate(arl, this.store, this.materialDataService);
                if (isNotNullOrUndefined(c)) {
                    costAmount = c;
                }
            }

            form = new FormGroup({
                costAmountWithoutTax: new FormControl<number>(arl ? (arl.Quantity || 0) * (costAmount || 0) : null, { nonNullable: true }),
                BaseCost: new FormControl<number>(arl ? arl.BaseCost : null, { nonNullable: true }),
                CostAmount: new FormControl<number>(arl ? costAmount : null, { nonNullable: true }),
                Quantity: new FormControl<number>(arl ? arl.Quantity : null, { nonNullable: true }),
                QuantityTypeId: new FormControl<number>(arl ? arl.QuantityTypeId : null, { nonNullable: true }),
                Information: new FormControl<string>(arl ? arl.Information : null, { nonNullable: true }),
                BookingText: new FormControl<string>(arl ? arl.BookingText : null, { nonNullable: true }),
                Type: new FormControl<AccountsReceivableLedgerTypeEnum>(arl ? arl.Type : AccountsReceivableLedgerTypeEnum.Arl, {
                    nonNullable: true,
                    validators: Validators.required,
                }),
                ResourceId: new FormControl<number>(arl ? arl.ResourceId : null, { nonNullable: true }),
                MaterialId: new FormControl<number>(arl ? arl.MaterialId : null, { nonNullable: true }),
                JobSpecificationId: new FormControl<number>(arl ? arl.JobSpecificationId : null, { nonNullable: true }),
                IsVisible: new FormControl<boolean>(arl ? arl.IsVisible : childrenVisible, { nonNullable: true }),
                IsOptional: new FormControl<boolean>(false, { nonNullable: true }),
                CrossedOut: new FormControl<boolean>(false, { nonNullable: true }),
                IndividuallyCostCalculation: new FormControl<boolean>(false, { nonNullable: true }),
                // nur für getARLTableData() Kompatibilität
                CostAmountAllowance: new FormControl<number>(null),
                QuantityFormula: new FormControl<string>(arl ? arl.QuantityFormula : null, { nonNullable: true }),
                QuantityFormulaUsedVariables: new FormControl<string[]>(arl ? arl.QuantityFormula ? mjsHelper.getUsedVariableNames(arl.QuantityFormula) :[] : [], { nonNullable: true }),
                SurchargeOverride: new FormControl<number | null>(null, { nonNullable: true })
            });
            if (arl?.Id) {
                this.setForm(arl.Id, form);
            }
        }
        return form;
    }
}
